export default __webpack_public_path__ + "static/media/dawn.21861662.jpeg";